import TherapistApiConnector from "@/Services/TherapyApi/Therapists";
import StripeAccountApiToStripeAccountTransformer from "@/Modules/Transformers/Therapist/StripeAccountApiToStripeAccount";

class UpdateStripeAccountActionHandler {
  constructor(
    private readonly therapistApiConnector = new TherapistApiConnector(),
    private readonly stripeAccountApiToStripeAccountTransformer = new StripeAccountApiToStripeAccountTransformer()
  ) {}

  public async handle() {
    const stripeAccountApi = await this.therapistApiConnector.updateStripeAccount();

    return this.stripeAccountApiToStripeAccountTransformer.transform(stripeAccountApi);
  }
}

export default UpdateStripeAccountActionHandler;
